import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  chileToggleValue: boolean;
  initvalue: boolean = false;

  constructor() { }

  ngOnInit() {


  }

  displayNode(event) {
    this.chileToggleValue = event;
  }




}
